(() => {
  const clampIndex = (index, length) => Math.max(0, Math.min(index, length - 1));

  function initSortSelects(root = document) {
    root.querySelectorAll('[data-sort-by]:not([data-sort-ready])').forEach((select) => {
      select.dataset.sortReady = 'true';
      select.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        window.location.href = url.toString();
      });
    });
  }

  function initProductGallery(gallery) {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const previousButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    const currentCounter = gallery.querySelector('[data-gallery-current]');
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    if (!track || slides.length === 0) return;

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;
    let scrollFrame = null;

    const updateState = (index) => {
      activeIndex = clampIndex(index, slides.length);

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

        if (!active) {
          slide.querySelectorAll('video').forEach((video) => video.pause());
        }
      });

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (currentCounter) currentCounter.textContent = String(activeIndex + 1);
    };

    const goTo = (index, options = {}) => {
      const nextIndex = clampIndex(index, slides.length);
      updateState(nextIndex);

      if (!desktopQuery.matches || options.forceScroll) {
        track.scrollTo({
          left: slides[nextIndex].offsetLeft,
          behavior: options.instant ? 'auto' : 'smooth'
        });
      }

      thumbnails[nextIndex]?.scrollIntoView({
        behavior: options.instant ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        goTo(Number(thumbnail.dataset.targetIndex || 0));
      });
    });

    previousButton?.addEventListener('click', () => {
      const nextIndex = activeIndex === 0 ? slides.length - 1 : activeIndex - 1;
      goTo(nextIndex);
    });

    nextButton?.addEventListener('click', () => {
      const nextIndex = activeIndex === slides.length - 1 ? 0 : activeIndex + 1;
      goTo(nextIndex);
    });

    track.addEventListener('scroll', () => {
      if (desktopQuery.matches || scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        const nearestIndex = slides.reduce((nearest, slide, index) => {
          const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
          const nearestDistance = Math.abs(slides[nearest].offsetLeft - track.scrollLeft);
          return currentDistance < nearestDistance ? index : nearest;
        }, 0);
        if (nearestIndex !== activeIndex) updateState(nearestIndex);
      });
    }, { passive: true });

    gallery.querySelectorAll('[data-gallery-zoom]').forEach((zoomArea) => {
      zoomArea.addEventListener('pointermove', (event) => {
        if (!desktopQuery.matches || gallery.dataset.enableZoom !== 'true') return;
        const bounds = zoomArea.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width) * 100;
        const y = ((event.clientY - bounds.top) / bounds.height) * 100;
        zoomArea.style.setProperty('--zoom-x', `${x}%`);
        zoomArea.style.setProperty('--zoom-y', `${y}%`);
      });
      zoomArea.addEventListener('pointerleave', () => {
        zoomArea.style.removeProperty('--zoom-x');
        zoomArea.style.removeProperty('--zoom-y');
      });
    });

    desktopQuery.addEventListener('change', () => {
      goTo(activeIndex, { instant: true, forceScroll: !desktopQuery.matches });
    });

    updateState(activeIndex);
    gallery.galleryGoTo = goTo;
  }

  function initProductForms(root = document) {
    root.querySelectorAll('[data-product-root]:not([data-product-ready])').forEach((productRoot) => {
      productRoot.dataset.productReady = 'true';
      const gallery = productRoot.querySelector('[data-product-gallery]');
      const variantSelect = productRoot.querySelector('[data-variant-select]');
      const price = productRoot.querySelector('[data-product-price]');
      const addButton = productRoot.querySelector('[data-add-to-cart]');

      if (!variantSelect) return;

      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        const mediaId = option.dataset.mediaId;
        const available = option.dataset.available === 'true';

        if (price && option.dataset.price) price.textContent = option.dataset.price;

        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available
            ? addButton.dataset.availableLabel
            : addButton.dataset.unavailableLabel;
        }

        if (gallery && mediaId) {
          const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
          const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
          if (mediaIndex >= 0 && typeof gallery.galleryGoTo === 'function') {
            gallery.galleryGoTo(mediaIndex);
          }
        }
      });
    });
  }

  function initTheme(root = document) {
    initSortSelects(root);
    root.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
    initProductForms(root);
  }

  document.addEventListener('DOMContentLoaded', () => initTheme(document));
  document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
})();
